import React from "react";
import point from "./../../../../../Images/point.png";

const TrendyHairHighlightIcy = () => {
  return (
    <div className="blogWhat-content">
      <h5>4. Icy Platinum Streaks for a Bold Edge ❄️</h5>
      <p>
        Icy platinum highlights are making a strong comeback in 2025! This
        cool-toned hair highlights color is ideal for those who love an edgy,
        modern look. These highlights add contrast and sleekness, especially on
        dark hair.
      </p>
      <ul>
        <h4>Why It’s Trending:</h4>
        <li>
          <span>
            <img src={point} alt="point" />
            Creates a bold and striking effect{" "}
          </span>
        </li>
        <li>
          <span>
            <img src={point} alt="point" /> Works best on cool-toned complexions
          </span>
        </li>
        <li>
          <span>
            <img src={point} alt="point" /> High-maintenance but ultra-glamorous
          </span>
        </li>
      </ul>
    </div>
  );
};

export default TrendyHairHighlightIcy;
